import { render, staticRenderFns } from "./ReviewDetailIframe.vue?vue&type=template&id=0958c3ea&"
import script from "./ReviewDetailIframe.vue?vue&type=script&lang=ts&"
export * from "./ReviewDetailIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports